import { render } from "./FirmaPlanTratamiento.vue?vue&type=template&id=4f2b62fc&scoped=true"
import script from "./FirmaPlanTratamiento.vue?vue&type=script&lang=js"
export * from "./FirmaPlanTratamiento.vue?vue&type=script&lang=js"

import "./FirmaPlanTratamiento.vue?vue&type=style&index=0&id=4f2b62fc&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2b62fc"]])

export default __exports__